import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useMemo, useState } from 'react';
import { API_BASE_URL } from '@/lib/api';

function ProfessionalRedeemLandingPage() {
  const { code } = Route.useParams();
  const [clickTracked, setClickTracked] = useState(false);
  const deepLink = useMemo(
    () => `https://harborcoparent.com/redeem/pro/${encodeURIComponent(code)}`,
    [code],
  );

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        await fetch(
          `${API_BASE_URL}/v1/professional-codes/${encodeURIComponent(code)}/click`,
          { method: 'POST' },
        );
      } catch {
        // Best-effort analytics + click tracking.
      } finally {
        if (!cancelled) setClickTracked(true);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <div className='min-h-screen bg-sky-light'>
      <main className='mx-auto max-w-xl px-6 py-14'>
        <div className='rounded-2xl border border-gray-200 bg-white p-6 shadow-sm'>
          <p className='inline-flex rounded-full bg-[#018A9D]/10 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-[#016a78]'>
            Harbor invite
          </p>
          <h1 className='mt-3 text-2xl font-semibold text-gray-900'>You were invited to Harbor</h1>
          <p className='mt-2 text-sm text-gray-600'>
            Install Harbor and then continue with the same link to redeem your professional
            invite trial.
          </p>

          <div className='mt-5 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3'>
            <p className='text-xs uppercase tracking-wide text-gray-500'>Invite code</p>
            <p className='mt-1 font-mono text-sm text-gray-900'>{code}</p>
          </div>

          <div className='mt-5 space-y-2'>
            <a
              href={deepLink}
              className='block w-full rounded-xl bg-[#018A9D] px-4 py-2.5 text-center text-sm font-semibold text-white'
            >
              Continue in Harbor
            </a>
            <a
              href='https://apps.apple.com/us/app/harbor-coparent/id1596817041'
              className='block w-full rounded-xl border border-gray-300 px-4 py-2.5 text-center text-sm font-semibold text-gray-700'
            >
              Get Harbor on iPhone
            </a>
            <a
              href='https://play.google.com/store/apps/details?id=com.leakingsieve.harbor'
              className='block w-full rounded-xl border border-gray-300 px-4 py-2.5 text-center text-sm font-semibold text-gray-700'
            >
              Get Harbor on Android
            </a>
          </div>
          <p className='mt-4 text-xs text-gray-500'>
            {clickTracked
              ? 'Invite link tracked.'
              : 'Preparing your invite…'}
          </p>
        </div>
      </main>
    </div>
  );
}

export const Route = createFileRoute('/redeem/pro/$code')({
  component: ProfessionalRedeemLandingPage,
});
